// extracted by mini-css-extract-plugin
export default {"description":"restorePasswordAfterLeakForm-module__description__uzQSf","email":"restorePasswordAfterLeakForm-module__email__VJ9si"};